import { useEffect, useRef, useState } from "react";
import {
  useNavigate,
  useLocation,
  Link,
  useSearchParams,
} from "react-router-dom";
import Sidebar from "../components/SidebarUpdate";

import Category from "../components/Category";
import { ClipLoader } from "react-spinners";
import Breadcrumb from "../components/Breadcrumb";
import apiInstance from "../apiConfig/apiinstance";
import DummyImage from "../assest/images/dummy_image.jpg";
import Pagination from "../components/Pagination";

const ProductUpdate = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [subCategory, setSubcategory] = useState([]);
  const [categoryImages, setCatagoryImages] = useState([]);
  const [searchParams, setSearchParams] = useSearchParams();
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [error, setError] = useState(null);
  const [categoryLoading, setSubCategoryLoading] = useState(false);
  const [loading, setLoading] = useState(false);

  const previousCategoryRef = useRef(null);

  // Get current page from URL, default to 1
  const currentPage = parseInt(searchParams.get("currentPage")) || 1;
  const currentCategory = location.pathname.split("/")[2];

  console.log("current category", currentCategory);

  const fetchSubCategoryData = async (lastCategory) => {
    // console.log("fetchSubCategoryData", lastCategory);
    setSubCategoryLoading(true);
    setError(null);
    try {
      const { data } = await apiInstance.get(
        `/api/cat/v1/child-categories/?slug=${lastCategory}`,
      );

      if (data.status === 200) {
        if (data?.data?.length === 0) {
          setError("No SubCategory found");
        }

        setSubcategory(data?.data || []);
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Failed to load data");
    } finally {
      setSubCategoryLoading(false);
    }
  };

  const fetchCategoryImages = async (categoryParam, page = 1) => {
    if (!categoryParam) return;

    setLoading(true);
    setError(null);
    try {
      let url =
        categoryParam === "bestseller"
          ? `api/style/v1/category-best-seller/${currentCategory}/`
          : `/api/cat/v1/category-photo/${categoryParam}/?page=${page}`;

      const res = await apiInstance.get(url);

      if (res.status === 200) {
        setCatagoryImages(res.data.data.results);
        setTotalPages(res.data.data.total_pages);
        setTotalItems(res.data.data.count || 0);
      }
    } catch (error) {
      setError(error?.response?.data?.message || "Failed to load data");
    } finally {
      setLoading(false);
    }
  };

  const getCategorySegments = (path) => {
    const segments = path.split("/").filter(Boolean);
    const idx = segments.indexOf("filter-product");
    return idx !== -1 ? segments.slice(idx + 1) : [];
  };

  useEffect(() => {
    const segments = getCategorySegments(location.pathname);
    const currentCategory = segments[segments?.length - 1];

    if (currentCategory) {
      // Check if this is a category change (not a page change)
      const isCategoryChange =
        previousCategoryRef.current &&
        previousCategoryRef.current !== currentCategory;

      if (isCategoryChange && currentPage > 1) {
        // Category changed and we're not on page 1, reset to page 1
        const params = new URLSearchParams(searchParams);
        params.delete("currentPage");
        setSearchParams(params, { replace: true });
        // Don't fetch data here, let the next effect handle it
        return;
      }

      // Update the previous category ref
      previousCategoryRef.current = currentCategory;

      // Fetch data for current category and page
      fetchSubCategoryData(currentCategory);
      fetchCategoryImages(currentCategory, currentPage);
    } else {
      setSubcategory([]);
      setCatagoryImages([]);
      previousCategoryRef.current = null;
    }

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [location.pathname, currentPage]);

  const handlePageChange = (page) => {
    const params = new URLSearchParams(searchParams);
    if (page === 1) {
      params.delete("currentPage"); // Remove param for page 1
    } else {
      params.set("currentPage", page);
    }
    setSearchParams(params);
  };

  const handleCategoryChange = (newPath) => {
    navigate(newPath);
  };

  const handleProductClick = (styleId) => {
    // const segments = getCategorySegments(location.pathname);
    // const currentCategory = segments[segments?.length - 1];

    if (currentCategory) {
      // Store the complete navigation state for back button
      const navigationState = {
        pathname: location.pathname,
        search: location.search,
        currentPage: currentPage,
        category: currentCategory,
      };
      sessionStorage.setItem(
        "lastNavigationState",
        JSON.stringify(navigationState),
      );
    }

    navigate(`/${currentCategory}/product-detail/${styleId}`);
  };

  return (
    <div className="parent_Container">
      <div className="content_wrapper ">
        <Sidebar
          logo="FP ONE"
          mainLoading={loading}
          currentPage={currentPage}
        />

        <div
          style={{ overflowX: "hidden", width: "100%" }}
          className="md:ml-[18rem] mt-[5rem] md:mt-0"
        >
          {categoryLoading ? (
            <p style={{ fontSize: "18px", color: "gray" }}>
              Loading Categories...
            </p>
          ) : (
            <Category
              SubCategory={subCategory}
              subCategoryError={error}
              onCategoryClick={handleCategoryChange}
            />
          )}

          {subCategory.length > 0 && <div className="separator"></div>}

          <Breadcrumb onCategoryClick={handleCategoryChange} isMSR={false} />

          {loading ? (
            <div className="loader-container">
              <ClipLoader color="#3498db" loading={loading} size={50} />
            </div>
          ) : categoryImages?.length === 0 ? (
            <div className="no-products loader-container">
              No Products Found
            </div>
          ) : (
            <div className="product_container">
              {categoryImages?.map((product) => (
                <div className="cart" key={product.style_id}>
                  <div
                    className="image-wrapper relative"
                    onClick={() => handleProductClick(product.style_id)}
                    style={{ cursor: "pointer" }}
                  >
                    <img
                      src={
                        product?.cover_image ||
                        product?.photos?.[0]?.url ||
                        DummyImage
                      }
                      alt="Selected Product"
                      className="image"
                      loading="lazy"
                    />

                    {!product?.cover_image && !product?.photos?.[0]?.url && (
                      <div className="image-not-found-overlay">
                        <span className="image-not-found-text">
                          Image not found
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          )}

          {categoryImages?.length > 0 && totalPages > 1 && (
            <div className="mt-4">
              <Pagination
                totalPages={totalPages}
                currentPage={currentPage}
                onPageChange={handlePageChange}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductUpdate;
